import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { NavContext } from "@-/dev.improve.haniverse.routes.nav._context";
import { LearnLayoutContext } from "@-/dev.improve.haniverse.routes.nav.app.learn._context";
import { useCallback } from "react";

/**
 * Opens the deck from Learn's Start (the summary card's, or the map home's Welcome Back). The deck
 * `replace`s the route it opens from, so there is no route to go back to; instead this leaves a
 * `LearnSummaryDeckEntry` for the deck session it opens, whose first-card Undo returns to where
 * Start was pressed. Entering the deck starts the Learn flow, which ends the map home for the rest
 * of the app session.
 */
export function useStartLearnDeckFromSummary() {
  const [setHasLearnFlowStartedThisSession] = useContextSelectors(
    NavContext,
    (c) => c.setHasLearnFlowStartedThisSession,
  );
  const [summaryDeckEntryRef] = useContextSelectors(
    LearnLayoutContext,
    (c) => c.summaryDeckEntryRef,
  );
  return useCallback(
    async (openDeck: () => Promise<unknown>, { returnToMapHome }: { returnToMapHome: boolean }) => {
      summaryDeckEntryRef.current = { returnToMapHome };
      try {
        await openDeck();
      } catch (error) {
        // The deck never opened, so a later unrelated deck entry must not claim this summary.
        summaryDeckEntryRef.current = null;
        throw error;
      }
      setHasLearnFlowStartedThisSession(true);
    },
    [setHasLearnFlowStartedThisSession, summaryDeckEntryRef],
  );
}
